import { LtlQuoteViewModel } from '@store/orders/types';

/** Which screen is hosting the row. Drives what the row shows, never how it behaves. */
export type QuoteDetailsVariant =
  | 'savedQuotes'
  | 'history'
  | 'newQuote'
  | 'testLane';

/** Insurance figures normalised from either the saved-quote or the new-quote source shape. */
export interface QuoteDetailsInsurance {
  premium: number;
  serviceFee: number;
  declaredValue: number;
}

/** Behaviour is injected by the host; the row never touches the router or stores. */
export interface QuoteDetailsActions {
  onSelectQuote?: (quote: LtlQuoteViewModel) => Promise<void> | void;
  onAddInsurance?: (quote: LtlQuoteViewModel) => void;
  onSelectInsuranceQuote?: (quote: LtlQuoteViewModel) => void;
  onOpenLiabilityInfo?: (quote: LtlQuoteViewModel) => void;
}

export interface QuoteDetailsLabels {
  select: string;
  addInsurance: string;
  selectInsurance: string;
}

export const DEFAULT_QUOTE_DETAILS_LABELS: QuoteDetailsLabels = {
  select: 'Select Quote',
  addInsurance: 'Add Insurance',
  selectInsurance: 'Select Insurance Quote',
};

export interface QuoteDetailsRowRenderProps {
  variant: QuoteDetailsVariant;
  quote: LtlQuoteViewModel;
  customerId?: number;
  insurance?: QuoteDetailsInsurance;
  actions?: QuoteDetailsActions;
  labels?: Partial<QuoteDetailsLabels>;
  carrierNameDataTestId?: string;
}

export const showsActions = (variant: QuoteDetailsVariant) =>
  variant === 'savedQuotes' || variant === 'newQuote';

export const showsTerminalInfo = (variant: QuoteDetailsVariant) =>
  variant !== 'testLane';
